var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#00EFC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.6666C19.4604 12.6666 20.5414 13.1144 21.3385 13.9114C22.1355 14.7085 22.5833 15.7895 22.5833 16.9166V21.875H19.7499V16.9166C19.7499 16.5409 19.6007 16.1806 19.335 15.9149C19.0693 15.6492 18.709 15.5 18.3333 15.5C17.9575 15.5 17.5972 15.6492 17.3315 15.9149C17.0658 16.1806 16.9166 16.5409 16.9166 16.9166V21.875H14.0833V16.9166C14.0833 15.7895 14.531 14.7085 15.328 13.9114C16.1251 13.1144 17.2061 12.6666 18.3333 12.6666V12.6666Z",
    stroke: "#00EFC1",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 13.375H8.41675V21.875H11.2501V13.375Z",
    stroke: "#00EFC1",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83341 11.25C10.6158 11.25 11.2501 10.6157 11.2501 9.83329C11.2501 9.05089 10.6158 8.41663 9.83341 8.41663C9.05101 8.41663 8.41675 9.05089 8.41675 9.83329C8.41675 10.6157 9.05101 11.25 9.83341 11.25Z",
    stroke: "#00EFC1",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.739fe41776eb77c7b43a22dd4fdc69a5.svg";
export { ForwardRef as ReactComponent };